import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { LocationsTurnsService } from 'src/app/services/turns-services/locations-turns-service/locations-turns.service';
import { ActivatedRoute, Router } from '@angular/router';
import { EMPTY, Subscription } from 'rxjs';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { CentersCentersService } from 'src/app/services/centers-services/centers-centers-service/centers-centers.service';
import { catchError, tap } from 'rxjs/operators';

@Component({
  selector: 'app-turns-new-location-creation-card',
  templateUrl: './turns-new-location-creation-card.component.html',
  styleUrls: ['./turns-new-location-creation-card.component.scss']
})
export class TurnsNewLocationCreationCardComponent implements OnInit, OnDestroy {

  centerList;
  addNewLocationSubscription: Subscription;
  iotDeviceSubscription: Subscription;
  showButton: boolean;
  availableStatus;
  availableIotDevices;

  basicDataForm = new FormGroup({
    active: new FormControl(true),
    selectedCenter: new FormControl(null, Validators.required),
    name: new FormControl(null, Validators.required),
    number: new FormControl(null, Validators.required),
    selectedStatus: new FormControl(null, Validators.required),
    selectedIotDevice: new FormControl(null, Validators.required)
  });

  constructor(private userStorageService: UserStorageService,
              private locationsTurnsService: LocationsTurnsService,
              private centerService: CentersCentersService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private snackbarService: SnackBarService,
              private spinnerService: SpinnerService) {
                this.showButton = true;
                this.availableStatus = [{InternalId: 'OPEN', value: 'OPENED'}, {InternalId: 'BUSY', value: 'BUSY'}, {InternalId: 'CLOSE', value: 'CLOSED'}];
  }

  ngOnInit() {
    this.centerList = this.userStorageService.getCenterList();
  }

  public getIotDevices() {
    this.iotDeviceSubscription = this.centerService.getIotDevices(this.getSelectedCenterInternalId()).pipe(
      tap(o => this.availableIotDevices = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  public addNewLocation() {
    this.showButton = false;
    this.spinnerService.show('location-new-spinner');
    const validation = this.validateForm();
    if (validation === true) {
      this.addNewLocationSubscription = this.locationsTurnsService.addNewLocation(this.basicDataForm.get('active').value, this.getSelectedCenterInternalId(), this.basicDataForm.get('name').value, this.basicDataForm.get('number').value, this.getSelectedStatus(), this.getSelectedIotDevice()).subscribe(
        (res) => {
          this.showButton = true;
          this.locationsTurnsService.refreshLocation();
          this.spinnerService.hide('location-new-spinner');
          this.snackbarService.open('turns-page.snackbar messages.add location success', 'success');
          this.router.navigate(['../locations'], { relativeTo: this.activatedRoute.parent });
        },
        (error) => {
          this.showButton = true;
          this.locationsTurnsService.refreshLocation();
          this.spinnerService.hide('location-new-spinner');
          this.snackbarService.open(error['error']['message'], 'error');
        }
      );
    } else {
      this.showButton = true;
      this.spinnerService.hide('location-new-spinner');
      this.snackbarService.open(validation, 'error');
    }
  }

  public cancelDesk() {
    this.router.navigate(['../locations'], { relativeTo: this.activatedRoute.parent });
  }

  public validateForm() {
   if (!this.basicDataForm.get('selectedCenter').valid) {
      return 'turns-page.snackbar messages.selected center location error';
    } else if (!this.basicDataForm.get('name').valid) {
      return 'turns-page.snackbar messages.name location error';
    } else if (!this.basicDataForm.get('number').valid) {
      return 'turns-page.snackbar messages.number location error';
    } else if (!this.basicDataForm.get('selectedStatus').valid) {
      return 'turns-page.snackbar messages.status location error';
    } else {
      return true;
    }
  }

  public getSelectedCenterInternalId() {
    if (this.centerList.length === 1) {
      return this.centerList[0].InternalId;
    } else {
      if (this.basicDataForm.get('selectedCenter').value) {
        return this.basicDataForm.get('selectedCenter').value.InternalId;
      } else {
        return null;
      }
    }
  }

  public getSelectedStatus() {
    if (this.availableStatus.length === 1) {
      return this.availableStatus[0].InternalId;
    } else {
      if (this.basicDataForm.get('selectedStatus').value) {
        return this.basicDataForm.get('selectedStatus').value.InternalId;
      } else {
        return null;
      }
    }
  }

  public getSelectedIotDevice() {
    if (this.availableIotDevices.length === 1) {
      return this.availableIotDevices[0].InternalId;
    } else {
      if (this.basicDataForm.get('selectedIotDevice').value) {
        return this.basicDataForm.get('selectedIotDevice').value.InternalId;
      } else {
        return null;
      }
    }
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.InternalId === op2.InternalId;
    }
  }

  ngOnDestroy() {
    if (this.addNewLocationSubscription) { this.addNewLocationSubscription.unsubscribe(); }
  }
}
